// extracted by mini-css-extract-plugin
export default {"root":"m0eIahcP47KemIX5PH4P","placeHolderShimmer":"wwBA4wW6IH9Y9CV5YEZ1"};